/* Vital Tail — product page behaviour (written for this store) */
(function () {
  'use strict';
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* countdown bar: evergreen timer from page load (H/M/S on the element) */
  function initCountdownBars() {
    document.querySelectorAll('[data-hp-countdown]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var h = parseInt(el.dataset.hours || '0', 10), m = parseInt(el.dataset.minutes || '0', 10), s = parseInt(el.dataset.seconds || '0', 10);
      var end = Date.now() + ((h * 60 + m) * 60 + s) * 1000;
      var hh = el.querySelector('[data-hh]'), mm = el.querySelector('[data-mm]'), ss = el.querySelector('[data-ss]');
      function tick() {
        var diff = Math.max(0, end - Date.now()), t = Math.floor(diff / 1000);
        hh.textContent = pad(Math.floor(t / 3600)); mm.textContent = pad(Math.floor((t % 3600) / 60)); ss.textContent = pad(t % 60);
        if (diff <= 0) clearInterval(id);
      }
      tick(); var id = setInterval(tick, 1000);
    });
  }

  /* "Ends in" timer: counts down to local midnight */
  function initScarcity() {
    document.querySelectorAll('[data-hp-midnight]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      function tick() {
        var now = new Date(), end = new Date(now); end.setHours(23, 59, 59, 999);
        var t = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = pad(Math.floor(t / 3600)) + ':' + pad(Math.floor((t % 3600) / 60)) + ':' + pad(t % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* shipping line: tomorrow's date + country flag */
  function initShipping() {
    document.querySelectorAll('[data-hp-ship-date]').forEach(function (el) {
      var d = new Date(); d.setDate(d.getDate() + 1);
      el.textContent = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '');
    });
    document.querySelectorAll('[data-hp-flag]').forEach(function (el) {
      var code = (el.dataset.hpFlag || 'US').toUpperCase();
      if (code.length !== 2) return;
      el.textContent = String.fromCodePoint.apply(null, code.split('').map(function (c) { return 0x1F1E6 + c.charCodeAt(0) - 65; }));
    });
  }

  /* bundle bar: pick a variant for the add-to-cart form */
  function initBundles() {
    document.querySelectorAll('.hp-bundles').forEach(function (block) {
      if (block.dataset.ready) return; block.dataset.ready = '1';
      var section = block.closest('.shopify-section') || document;
      var bars = block.querySelectorAll('.hp-bar[data-variant-id]');
      function apply(bar) {
        bars.forEach(function (b) { b.classList.toggle('hp-bar--selected', b === bar); var r = b.querySelector('input[type=radio]'); if (r) r.checked = (b === bar); });
        var id = bar.dataset.variantId;
        if (!id) return;
        section.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
          input.value = id; input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        section.querySelectorAll('[data-hp-atc-price]').forEach(function (p) { p.textContent = bar.dataset.price || ''; });
        if (/\/products\//.test(window.location.pathname)) { try { var url = new URL(window.location); url.searchParams.set('variant', id); window.history.replaceState({}, '', url); } catch (e) {} }
      }
      bars.forEach(function (bar) {
        bar.addEventListener('click', function () { apply(bar); });
        bar.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); apply(bar); } });
      });
      var preselected = block.querySelector('.hp-bar--selected[data-variant-id]') || bars[0];
      if (preselected) apply(preselected);
      var subs = block.querySelector('.hp-subs');
      if (subs) {
        var toggle = function () { subs.setAttribute('aria-checked', subs.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); };
        subs.addEventListener('click', toggle);
        subs.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      }
    });
  }

  /* real results: mobile dots follow the scrolled card */
  function initRealResults() {
    document.querySelectorAll('.hp-rr').forEach(function (root) {
      var row = root.querySelector('.hp-rr__row'), dots = root.querySelectorAll('.hp-rr__dot');
      if (!row || !dots.length) return;
      var cards = row.querySelectorAll('.hp-rr__card'), ticking = false;
      function update() {
        var left = row.scrollLeft + row.clientWidth / 2, best = 0, bestD = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - left); if (d < bestD) { bestD = d; best = i; } });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
        ticking = false;
      }
      row.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); }); });
      update();
    });
  }

  /* ingredients: mobile carousel */
  function initIngredients() {
    document.querySelectorAll('.hp-ingr__carousel').forEach(function (car) {
      var track = car.querySelector('.hp-ingr__track'), slides = car.querySelectorAll('.hp-ingr__slide');
      var prev = car.querySelector('.hp-ingr__arrow--left'), next = car.querySelector('.hp-ingr__arrow--right'), i = 0;
      function go(n) {
        i = Math.max(0, Math.min(slides.length - 1, n));
        var w = slides[0].offsetWidth + 20;
        track.style.transform = 'translateX(' + (-i * w) + 'px)';
        prev.disabled = i === 0; next.disabled = i >= slides.length - 1;
      }
      prev.addEventListener('click', function () { go(i - 1); });
      next.addEventListener('click', function () { go(i + 1); });
      var x0 = 0;
      track.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].screenX; }, { passive: true });
      track.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].screenX - x0; if (dx < -50) go(i + 1); if (dx > 50) go(i - 1); }, { passive: true });
      window.addEventListener('resize', function () { go(i); });
      go(0);
    });
  }

  /* expert recommendations slider */
  function initExperts() {
    document.querySelectorAll('.hp-exp').forEach(function (root) {
      var slider = root.querySelector('.hp-exp__slider'), slides = root.querySelectorAll('.hp-exp__slide');
      var prev = root.querySelector('.hp-exp__arrow--prev'), next = root.querySelector('.hp-exp__arrow--next'), dots = root.querySelectorAll('.hp-exp__dot'), i = 0;
      function perView() { return window.innerWidth >= 750 ? 2 : 1; }
      function maxIndex() { return Math.max(0, slides.length - perView()); }
      function go(n) {
        i = Math.max(0, Math.min(maxIndex(), n));
        var w = slides[0].offsetWidth + 10;
        slider.style.transform = 'translateX(' + (-i * w) + 'px)';
        dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
      }
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var x0 = 0;
      slider.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].screenX; }, { passive: true });
      slider.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].screenX - x0; if (dx < -50) go(i + 1); if (dx > 50) go(i - 1); }, { passive: true });
      window.addEventListener('resize', function () { go(i); });
      go(0);
    });
  }

  /* faq accordion */
  function initFaq() {
    document.querySelectorAll('.hp-faq__item').forEach(function (item) {
      var btn = item.querySelector('.hp-faq__q'), ans = item.querySelector('.hp-faq__a');
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('active');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0';
      });
    });
  }

  /* reviews: read more / show more */
  function initReviews() {
    document.querySelectorAll('.hp-pr').forEach(function (root) {
      root.querySelectorAll('.hp-pr__card').forEach(function (card) {
        var text = card.querySelector('.hp-pr__text'), more = card.querySelector('.hp-pr__more');
        if (!text || !more) return;
        var check = function () { if (!card.classList.contains('is-open')) more.hidden = text.scrollHeight <= text.clientHeight + 2; };
        more.addEventListener('click', function () { card.classList.add('is-open'); });
        check(); window.addEventListener('resize', check);
      });
      var btn = root.querySelector('.hp-pr__showbtn');
      if (btn) btn.addEventListener('click', function () {
        root.querySelectorAll('.hp-pr__card[hidden]').forEach(function (c) { c.hidden = false; });
        btn.closest('.hp-pr__showmore').hidden = true;
        root.querySelectorAll('.hp-pr__card').forEach(function (card) {
          var text = card.querySelector('.hp-pr__text'), more = card.querySelector('.hp-pr__more');
          if (text && more && !card.classList.contains('is-open')) more.hidden = text.scrollHeight <= text.clientHeight + 2;
        });
      });
    });
  }

  function init() { initCountdownBars(); initScarcity(); initShipping(); initBundles(); initRealResults(); initIngredients(); initExperts(); initFaq(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
